import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CopyButtonProps {
  onClick: () => void;
  tooltipTitle?: string;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
}

const CopyButton: React.FC<CopyButtonProps> = ({
  onClick,
  tooltipTitle = "Copy to clipboard",
  tooltipPlacement = "top",
}) => {
  return (
    <Tooltip title={tooltipTitle} placement={tooltipPlacement}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          color: "#537ea0",
          "&:hover": {
            backgroundColor: "rgba(83, 126, 160, 0.1)",
          },
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
